import React, { createContext, useContext, useState, useCallback } from 'react';
import dataStore from '../utils/dataStore';

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [blogs, setBlogs] = useState(() => dataStore.getBlogs());
  const [projects, setProjects] = useState(() => dataStore.getProjects());

  const addBlog = useCallback((blog) => setBlogs(dataStore.addBlog(blog)), []);
  const updateBlog = useCallback((id, updates) => setBlogs(dataStore.updateBlog(id, updates)), []);
  const deleteBlog = useCallback((id) => setBlogs(dataStore.deleteBlog(id)), []);

  const addProject = useCallback((project) => setProjects(dataStore.addProject(project)), []);
  const addProjects = useCallback((list) => setProjects(dataStore.addProjects(list)), []);
  const updateProject = useCallback((id, updates) => setProjects(dataStore.updateProject(id, updates)), []);
  const deleteProject = useCallback((id) => setProjects(dataStore.deleteProject(id)), []);

  return (
    <DataContext.Provider
      value={{
        blogs, projects,
        addBlog, updateBlog, deleteBlog,
        addProject, addProjects, updateProject, deleteProject,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  const ctx = useContext(DataContext);
  if (!ctx) throw new Error('useData must be used within a DataProvider');
  return ctx;
}
